<template>
  <div class="web-app-selection-container">
    <div class="web-apps">
      <h2>{{ $t('wdm.views.webAppSelection.labels.selectWebApp', 'Select a WebApp') }}</h2>
      <div
        class="pager-top"
        v-if="pagesLength > 1 && !$asyncComputed.webAppsRequest.updating">
        <v-pagination
          v-model="pagination.page"
          :length="pagesLength"
          :total-visible="7"
          circle />
      </div>
      <div
        v-if="$asyncComputed.webAppsRequest.updating"
        class="progress-bar">
        <v-progress-circular
          :size="70"
          :width="7"
          color="primary"
          indeterminate />
      </div>
      <div
        class="no-data"
        v-else-if="!$asyncComputed.webAppsRequest.updating && total === 0">
        <div>
          {{ $t('wdm.views.webAppSelection.labels.noData', 'No WebApp available') }}
        </div>
      </div>
      <div class="webapp-tiles">
        <WebAppCard
          :class="`webapp-card`"
          v-for="webApp in webApps"
          :key="webApp.id"
          :item="webApp"
          :can-like="false">
          <template slot="commands">
            <div>
              <v-btn
                class="open-btn"
                icon
                small
                @click="openWebStory(webApp)">
                <v-icon small>
                  fas fa-folder-open
                </v-icon>
              </v-btn>
            </div>
          </template>
        </WebAppCard>
      </div>
    </div>
    <div
      class="pager-bottom"
      v-if="pagesLength > 1 && !$asyncComputed.webAppsRequest.updating">
      <v-pagination
        v-model="pagination.page"
        :length="pagesLength"
        :total-visible="7"
        circle />
    </div>
  </div>
</template>

<script>
import { webAppDataSource } from 'server-model'
import { DESIGN_ENVIRONMENT_DTO } from '../constants/environment'
import WebAppCard from 'server-model/src/components/WebAppCard'
import { mapActions } from 'vuex'

export default {
  asyncComputed: {
    webAppsRequest () {
      return webAppDataSource.summary({ page: this.pagination.page - 1, size: 10, sort: 'updatedOn,desc', filter: `environment.id==${DESIGN_ENVIRONMENT_DTO.id}` })
    }
  },
  data () {
    return {
      schema: webAppDataSource.schema,
      pagination: {
        page: 1,
        size: 10
      },
      total: 0
    }
  },
  components: {
    WebAppCard
  },
  watch: {
    webApps (value) {
      this.total = value.length
    }
  },
  computed: {
    webApps () {
      return this.webAppsRequest && this.webAppsRequest.content
    },
    pagesLength () {
      return Math.ceil(this.total / this.pagination.size)
    }
  },
  methods: {
    ...mapActions('wdm', [
      'openWebStory'
    ])
  }
}
</script>

<style lang="scss" scoped>
  @import "~common-assets/scss/we";

  .web-app-selection-container {
    @extend .full-size;
    @extend .flex-column;
    @extend .v-overflow;

    .progress-bar {
      @extend .full-size;
      position: relative;

      .v-progress-circular {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: (-50%, -50%);
      }
    }

    .web-apps {
      @extend .full-size;
      h2 {
        text-align: center;
      }

      .webapp-tiles {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        .webapp-card {
          display: grid;
          width: 50%;
        }
      }
    }

    .open-btn {
      margin-bottom: 2px;
    }

    .pager-top {
      text-align: center;
      margin-top: 10px;
    }

    .pager-bottom {
      text-align: center;
      margin-bottom: 10px;
    }
  }

  @include media-breakpoint-only(xs) {
    .web-app-selection-container {
      .web-apps {
        .webapp-tiles {
          .webapp-card {
            width: 100%;
          }
        }
      }
    }
  }

  @include media-breakpoint-up(lg) {
    .web-app-selection-container {
      .web-apps {
        .webapp-tiles {
          .webapp-card {
            width: 33.333%;
          }
        }
      }
    }
  }
</style>
